import * as React from 'react';
import { MdAdd } from 'react-icons/md';
import { AlternativeIdProps, AlternativeIdState, AlternativeIdItemData } from './types';
import { AlternativeIdItem } from './alternative-id-item';
import { alternativeIdFieldName } from './constants';
import { sfNames, sfParameters } from 'app/area/administration/edit/sf-names';

import style from './alternative-id.scss';
import { AddButton } from 'ui';
import { AdminPaperSubPanel } from 'app/area/administration/edit/components';

export class AlternativeId extends React.PureComponent<AlternativeIdProps, AlternativeIdState> {

  public constructor(props: AlternativeIdProps) {
    super(props);

    this.state = {
      data: props.data && props.data.map((item, index) => ({
        id: index,
        personId: item.personId,
        name: item.name
      })) || []
    };
  }

  private removeAlternativeId = (data: AlternativeIdItemData) => {

    const { formValues = {} } = this.props;

    this.setState({
      data: this.state.data.filter(item => item.id !== data.id)
    });

    this.props.clearValidation(sfNames.alternativeIds, {
      [sfParameters.personId]: formValues[alternativeIdFieldName(sfNames.personId, data.id)] as string
    });
  };

  private addAlternativeId = () => {

    const { data } = this.state;
    const id = data.length > 0 ? data[data.length - 1].id + 1 : 0;

    this.setState({
      data: [
        ...data,
        {
          id,
          personId: '',
          name: ''
        }
      ]
    });
  };

  public render() {

    const { formValues, validation, translation, readOnly, formComponent } = this.props;
    const fieldIds = this.state.data.map(item => item.id);

    return <AdminPaperSubPanel title={translation.alternative_id}>
      <div className={style.section}>
        <div className="row expanders-in-equal-cols">
          <div className="col-lg-12">

            {!readOnly && <AddButton icon={MdAdd} onClick={this.addAlternativeId} required={false}>
              {translation.add}
            </AddButton>}

            {this.state.data.map(item => <AlternativeIdItem
              key={item.id}
              data={item}
              formValues={formValues}
              validateFields={fieldIds}
              validation={validation}
              readOnly={readOnly}
              translation={translation}
              formComponent={formComponent}
              onRemove={this.removeAlternativeId}
            />)}
            {readOnly && this.state.data.length === 0 && <p className="no-content">
              {translation.no_alternative_id_has_been_added}
            </p>}
          </div>
        </div>
      </div>
    </AdminPaperSubPanel>;
  }
}
